(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiv-erfahrung"] && !Shopify.designMode) return;
  try {
    
(() => {
const announcement=document.body.querySelector('.announcement-bar__link[href*="#ContactFooter"]');if(announcement){announcement.setAttribute('href','#ContactFooter');announcement.addEventListener('click',event=>{if(!document.getElementById('KivNewsletterModal'))return;event.preventDefault();document.dispatchEvent(new CustomEvent('kiv:open-newsletter',{detail:{source:'header_bar'}}));});}
const root = document.querySelector('.kivr-native-offer');
if (!root || root.dataset.ready === 'true') return;
root.dataset.ready = 'true';
    const galleryTrack = root.querySelector('[data-kiv-gallery-track]');
    const gallerySlides = Array.from(root.querySelectorAll('[data-kiv-gallery-slide]'));
    const galleryNav = Array.from(root.querySelectorAll('[data-kiv-gallery-nav]'));
    const galleryPrev = root.querySelector('[data-kiv-gallery-prev]');
    const galleryNext = root.querySelector('[data-kiv-gallery-next]');
    let galleryIndex = 0;
    const setGalleryIndex = (index, move = false) => {
      const safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));
      galleryIndex = safeIndex;
      gallerySlides.forEach((slide, itemIndex) => {
        const isActive = itemIndex === safeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      galleryNav.forEach((button, itemIndex) => {
        const isActive = itemIndex === safeIndex;
        button.classList.toggle('is-active', isActive);
        if (isActive) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (move && galleryTrack) {
        galleryTrack.scrollTo({ left: galleryTrack.clientWidth * safeIndex, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    };
    const moveGallery = (direction) => {
      if (!gallerySlides.length) return;
      setGalleryIndex((galleryIndex + direction + gallerySlides.length) % gallerySlides.length, true);
    };
    galleryPrev?.addEventListener('click', () => moveGallery(-1));
    galleryNext?.addEventListener('click', () => moveGallery(1));
    galleryNav.forEach((button) => button.addEventListener('click', () => setGalleryIndex(Number(button.dataset.kivGalleryNav), true)));
    let galleryTicking = false;
    galleryTrack?.addEventListener('scroll', () => {
      if (galleryTicking) return;
      galleryTicking = true;
      window.requestAnimationFrame(() => {
        const index = galleryTrack.clientWidth ? Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) : 0;
        setGalleryIndex(index);
        galleryTicking = false;
      });
    }, { passive:true });
    galleryTrack?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      moveGallery(event.key === 'ArrowRight' ? 1 : -1);
    });

    let galleryResizeFrame = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(galleryResizeFrame);
      galleryResizeFrame = window.requestAnimationFrame(() => {
        galleryTrack?.scrollTo({ left: galleryTrack.clientWidth * galleryIndex, behavior: 'auto' });
      });
    }, { passive:true });


    const packages = Array.from(root.querySelectorAll('[data-kiv-package]'));
    const mainSubmit = root.querySelector('[data-kiv-main-submit]');
    const submitText = root.querySelector('[data-kiv-main-submit-text]');
    const finalSubmit = root.querySelector('[data-kiv-final-submit]');
    const finalSubmitText = root.querySelector('[data-kiv-final-submit-text]');
    const sticky = root.querySelector('[data-kiv-sticky]');
    const stickyLabel = root.querySelector('[data-kiv-sticky-label]');
    const stickyPrice = root.querySelector('[data-kiv-sticky-price]');

    const selectPackage = (card) => {
      const value = card.dataset.packageValue;
      packages.forEach((item) => {
        const isSelected = item.dataset.packageValue === value;
        item.classList.toggle('is-selected', isSelected);
        const input = item.querySelector('input');
        if (input) input.checked = isSelected;
      });
      if (mainSubmit) mainSubmit.dataset.variant = card.dataset.variant;
      if (submitText) submitText.textContent = card.dataset.cta;
      if (finalSubmit) finalSubmit.dataset.variant = card.dataset.variant;
      if (finalSubmitText) finalSubmitText.textContent = card.dataset.cta;
      if (stickyLabel) stickyLabel.textContent = card.dataset.label;
      if (stickyPrice) stickyPrice.textContent = card.dataset.price;
    };
    packages.forEach((card) => {
      const input = card.querySelector('input');
      input?.addEventListener('change', () => selectPackage(card));
    });
    const initialPackage = packages.find((card) => card.querySelector('input:checked'));
    if (initialPackage) selectPackage(initialPackage);

    root.querySelector('[data-kiv-sticky-submit]')?.addEventListener('click', () => {
      mainSubmit?.click();
    });

    const addToCart = async (button) => {
      const variantId = button.dataset.variant;
      if (!variantId || button.disabled) return;
      const label = button.querySelector('span');
      const originalLabel = label?.textContent || '';
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart?.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Wird hinzugefügt …';
      let cartAdded = false;
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Das Produkt konnte nicht hinzugefügt werden.');
        cartAdded = true;
        if (cart?.renderContents && result.sections) {
          const cartJsonUrl = `${window.routes?.cart_url || '/cart'}.js`;
          const cartResponse = await fetch(cartJsonUrl, {
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!cartResponse.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
          const cartState = await cartResponse.json();
          cartState.sections = result.sections;
          cart.renderContents(cartState);
          cart.classList.toggle('is-empty', cartState.item_count === 0);
        } else window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        if (cartAdded) {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }
        if (label) label.textContent = 'Bitte erneut versuchen';
        button.title = error.message;
        window.setTimeout(() => { if (label) label.textContent = originalLabel; }, 2500);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label && label.textContent === 'Wird hinzugefügt …') label.textContent = originalLabel;
      }
    };
    root.querySelectorAll('[data-kiv-add-to-cart]').forEach((button) => {
      button.addEventListener('click', () => addToCart(button));
    });


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiv-landing-b"] && !Shopify.designMode) return;
  try {
    
(() => {
const announcement=document.body.querySelector('.announcement-bar__link[href*="#ContactFooter"]');if(announcement){announcement.setAttribute('href','#ContactFooter');announcement.addEventListener('click',event=>{if(!document.getElementById('KivNewsletterModal'))return;event.preventDefault();document.dispatchEvent(new CustomEvent('kiv:open-newsletter',{detail:{source:'header_bar'}}));});}
const root = document.querySelector('.kivr-native-offer');
if (!root || root.dataset.ready === 'true') return;
root.dataset.ready = 'true';
    const galleryTrack = root.querySelector('[data-kiv-gallery-track]');
    const gallerySlides = Array.from(root.querySelectorAll('[data-kiv-gallery-slide]'));
    const galleryNav = Array.from(root.querySelectorAll('[data-kiv-gallery-nav]'));
    const galleryPrev = root.querySelector('[data-kiv-gallery-prev]');
    const galleryNext = root.querySelector('[data-kiv-gallery-next]');
    let galleryIndex = 0;
    const setGalleryIndex = (index, move = false) => {
      const safeIndex = Math.max(0, Math.min(index, gallerySlides.length - 1));
      galleryIndex = safeIndex;
      gallerySlides.forEach((slide, itemIndex) => {
        const isActive = itemIndex === safeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      galleryNav.forEach((button, itemIndex) => {
        const isActive = itemIndex === safeIndex;
        button.classList.toggle('is-active', isActive);
        if (isActive) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (move && galleryTrack) {
        galleryTrack.scrollTo({ left: galleryTrack.clientWidth * safeIndex, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    };
    const moveGallery = (direction) => {
      if (!gallerySlides.length) return;
      setGalleryIndex((galleryIndex + direction + gallerySlides.length) % gallerySlides.length, true);
    };
    galleryPrev?.addEventListener('click', () => moveGallery(-1));
    galleryNext?.addEventListener('click', () => moveGallery(1));
    galleryNav.forEach((button) => button.addEventListener('click', () => setGalleryIndex(Number(button.dataset.kivGalleryNav), true)));
    let galleryTicking = false;
    galleryTrack?.addEventListener('scroll', () => {
      if (galleryTicking) return;
      galleryTicking = true;
      window.requestAnimationFrame(() => {
        const index = galleryTrack.clientWidth ? Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth) : 0;
        setGalleryIndex(index);
        galleryTicking = false;
      });
    }, { passive:true });
    galleryTrack?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      moveGallery(event.key === 'ArrowRight' ? 1 : -1);
    });

    let galleryResizeFrame = 0;
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(galleryResizeFrame);
      galleryResizeFrame = window.requestAnimationFrame(() => {
        galleryTrack?.scrollTo({ left: galleryTrack.clientWidth * galleryIndex, behavior: 'auto' });
      });
    }, { passive:true });


    const packages = Array.from(root.querySelectorAll('[data-kiv-package]'));
    const mainSubmit = root.querySelector('[data-kiv-main-submit]');
    const submitText = root.querySelector('[data-kiv-main-submit-text]');
    const finalSubmit = root.querySelector('[data-kiv-final-submit]');
    const finalSubmitText = root.querySelector('[data-kiv-final-submit-text]');
    const sticky = root.querySelector('[data-kiv-sticky]');
    const stickyLabel = root.querySelector('[data-kiv-sticky-label]');
    const stickyPrice = root.querySelector('[data-kiv-sticky-price]');

    const selectPackage = (card) => {
      const value = card.dataset.packageValue;
      packages.forEach((item) => {
        const isSelected = item.dataset.packageValue === value;
        item.classList.toggle('is-selected', isSelected);
        const input = item.querySelector('input');
        if (input) input.checked = isSelected;
      });
      if (mainSubmit) mainSubmit.dataset.variant = card.dataset.variant;
      if (submitText) submitText.textContent = card.dataset.cta;
      if (finalSubmit) finalSubmit.dataset.variant = card.dataset.variant;
      if (finalSubmitText) finalSubmitText.textContent = card.dataset.cta;
      if (stickyLabel) stickyLabel.textContent = card.dataset.label;
      if (stickyPrice) stickyPrice.textContent = card.dataset.price;
    };
    packages.forEach((card) => {
      const input = card.querySelector('input');
      input?.addEventListener('change', () => selectPackage(card));
    });
    const initialPackage = packages.find((card) => card.querySelector('input:checked'));
    if (initialPackage) selectPackage(initialPackage);

    root.querySelector('[data-kiv-sticky-submit]')?.addEventListener('click', () => {
      mainSubmit?.click();
    });

    const addToCart = async (button) => {
      const variantId = button.dataset.variant;
      if (!variantId || button.disabled) return;
      const label = button.querySelector('span');
      const originalLabel = label?.textContent || '';
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart?.getSectionsToRender) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Wird hinzugefügt …';
      let cartAdded = false;
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Das Produkt konnte nicht hinzugefügt werden.');
        cartAdded = true;
        if (cart?.renderContents && result.sections) {
          const cartJsonUrl = `${window.routes?.cart_url || '/cart'}.js`;
          const cartResponse = await fetch(cartJsonUrl, {
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!cartResponse.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
          const cartState = await cartResponse.json();
          cartState.sections = result.sections;
          cart.renderContents(cartState);
          cart.classList.toggle('is-empty', cartState.item_count === 0);
        } else window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        if (cartAdded) {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }
        if (label) label.textContent = 'Bitte erneut versuchen';
        button.title = error.message;
        window.setTimeout(() => { if (label) label.textContent = originalLabel; }, 2500);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label && label.textContent === 'Wird hinzugefügt …') label.textContent = originalLabel;
      }
    };
    root.querySelectorAll('[data-kiv-add-to-cart]').forEach((button) => {
      button.addEventListener('click', () => addToCart(button));
    });


})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiv-offers-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.kivDataCompassBound) return;
    window.kivDataCompassBound = true;

    var timers = new WeakMap();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function activateChoice(bridge, choice) {
      bridge.querySelectorAll('[data-kiv-data-choice]').forEach(function (button) {
        var active = button === choice;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var title = bridge.querySelector('[data-kiv-detail-title]');
      var text = bridge.querySelector('[data-kiv-detail-text]');
      var example = bridge.querySelector('[data-kiv-detail-example]');
      var compass = bridge.querySelector('.kiv-compass');

      if (title) title.textContent = choice.dataset.title;
      if (text) text.textContent = choice.dataset.text;
      if (example) example.textContent = choice.dataset.example;
      if (compass && choice.dataset.angle) compass.style.setProperty('--needle-angle', choice.dataset.angle + 'deg');
    }

    function stopRotation(bridge) {
      var timer = timers.get(bridge);
      if (timer) window.clearInterval(timer);
      timers.delete(bridge);
    }

    function startRotation(bridge) {
      stopRotation(bridge);
      if (bridge.dataset.kivAutoRotate !== 'true' || bridge.dataset.kivVisible !== 'true' || bridge.dataset.kivPaused === 'true' || document.hidden || reducedMotion.matches) return;

      var choices = Array.from(bridge.querySelectorAll('[data-kiv-data-choice]'));
      if (choices.length < 2) return;
      var interval = Math.max(3000, Number(bridge.dataset.kivInterval) || 5000);

      timers.set(bridge, window.setInterval(function () {
        var current = choices.findIndex(function (button) {
          return button.getAttribute('aria-pressed') === 'true';
        });
        activateChoice(bridge, choices[(current + 1) % choices.length]);
      }, interval));
    }

    function initialiseBridge(bridge) {
      if (bridge.dataset.kivInitialised === 'true') return;
      bridge.dataset.kivInitialised = 'true';
      bridge.dataset.kivVisible = 'false';
      bridge.dataset.kivPaused = 'false';

      bridge.addEventListener('mouseenter', function () {
        bridge.dataset.kivPaused = 'true';
        stopRotation(bridge);
      });
      bridge.addEventListener('mouseleave', function () {
        bridge.dataset.kivPaused = 'false';
        startRotation(bridge);
      });
      bridge.addEventListener('focusin', function () {
        bridge.dataset.kivPaused = 'true';
        stopRotation(bridge);
      });
      bridge.addEventListener('focusout', function (event) {
        if (bridge.contains(event.relatedTarget)) return;
        bridge.dataset.kivPaused = 'false';
        startRotation(bridge);
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bridge.dataset.kivVisible = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting) startRotation(bridge);
          else stopRotation(bridge);
        });
      }, { threshold: 0.35 });
      observer.observe(bridge);
    }

    document.querySelectorAll('[data-kiv-data-bridge]').forEach(initialiseBridge);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-kiv-data-bridge]').forEach(initialiseBridge);
    });
    document.addEventListener('visibilitychange', function () {
      document.querySelectorAll('[data-kiv-data-bridge]').forEach(function (bridge) {
        if (document.hidden) stopRotation(bridge);
        else startRotation(bridge);
      });
    });
    document.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-kiv-data-choice]');
      if (!choice) return;
      var bridge = choice.closest('[data-kiv-data-bridge]');
      if (!bridge) return;
      activateChoice(bridge, choice);
      stopRotation(bridge);
      if (bridge.dataset.kivPaused !== 'true') startRotation(bridge);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiv-product-evidence"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-kiv-preview-open]');
    if (openButton) {
      const section = openButton.closest('.kiv-evidence');
      const dialog = section && section.querySelector('[data-kiv-preview-dialog]');
      const image = dialog && dialog.querySelector('[data-kiv-preview-image]');
      if (!dialog || !image) return;
      image.src = openButton.dataset.previewSrc;
      image.alt = openButton.dataset.previewAlt || 'Beispielseite';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-kiv-preview-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('[data-kiv-preview-dialog]')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiv-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!window.kivProofNavigationBound) {
    window.kivProofNavigationBound = true;
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-kiv-proof-nav]');
      if (!button) return;

      const shell = button.closest('[data-kiv-testimonials]');
      const track = shell && shell.querySelector('[data-kiv-proof-track]');
      const card = track && track.querySelector('.kiv-testimonial');
      if (!track || !card) return;

      const gap = parseFloat(window.getComputedStyle(track).columnGap) || 18;
      const direction = Number(button.getAttribute('data-kiv-proof-nav')) || 1;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
